import  { useState, useRef, useEffect } from "react";
import style from "./TumbLoadImage.module.css";
import { CDN_LINK } from "@globalConfig";

function TumbLoadImage(props) {
  const [showImage, setShowImage] = useState(false);
  const [src, setSrc] = useState(props.src);
  const imageElement = useRef();

  let imageElementScale = 1;
  let start = {};

  const distance = (event) => {
    return Math.hypot(
      event.touches[0].pageX - event.touches[1].pageX,
      event.touches[0].pageY - event.touches[1].pageY
    );
  };

  useEffect(() => {
    setShowImage(true);
    setSrc(props.src);
  }, [props.src]);

  const loadingDone = () => {
    setShowImage(true);
  };
  const onError = () => {
    setSrc(
      src.indexOf("/0x") > -1
        ? src.split("/0x")[0] + "/" + src.split("/0x")[1].split("/")[1]
        : CDN_LINK + "/assets/images/no_img.jpg"
    );
  };
  return (
    <>
      {!showImage && <div className={style.animatedBackground}></div>}

      <img
        onTouchStart={(event) => {
          if (event.touches.length === 2) {
            event.preventDefault(); // Prevent page scroll

            // Calculate where the fingers have started on the X and Y axis
            start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
            start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
            start.distance = distance(event);
          }
        }}
        onTouchMove={(event) => {
          if (event.touches.length === 2) {
            event.preventDefault();

            let scale;
            if (event.scale) {
              scale = event.scale;
            } else {
              const deltaDistance = distance(event);
              scale = deltaDistance / start.distance;
            }
            imageElementScale = Math.min(Math.max(1, scale), 4);

            const deltaX =
              ((event.touches[0].pageX + event.touches[1].pageX) / 2 -
                start.x) *
              2;
            const deltaY =
              ((event.touches[0].pageY + event.touches[1].pageY) / 2 -
                start.y) *
              2;

            const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
            imageElement.current.style.transform = transform;
            imageElement.current.style.WebkitTransform = transform;
            imageElement.current.style.zIndex = "9999";
          }
        }}
        onTouchEnd={(event) => {
          imageElement.current.style.transform = "";
          imageElement.current.style.WebkitTransform = "";
          imageElement.current.style.zIndex = "";
        }}
        ref={imageElement}
        className={[
          !showImage ? style.loading : undefined,
          props.className ? props.className : undefined,
          props.enableZoom ? "hasEvents" : undefined,
        ].join(" ")}
        src={src}
        onLoad={() => loadingDone()}
        onError={onError}
        alt=""
      />
    </>
  );
}

export default TumbLoadImage;